module.exports = __webpack_public_path__ + "img/seferjLogo.cbff3c0e.png";